<div class="orgApp-d-flex orgApp-justify-c-center orgApp-login">
    <mat-card class="orgApp-frgt-pwd-card">
        <div class="orgApp-d-flex orgApp-fgt-pwd-div orgApp-flex-dir-col">
            <div class="orgApp-d-flex orgApp-margin-left-20">
                <svg matPrefix width="24" height="24" class="orgApp-margin-top-38" fill="none" (click)="showLogin()">
                   <use xlink:href="#back-arrow"></use>
                </svg>
                <mat-card-title class="orgApp-frgt-pwd-heading orgApp-frgt-pwd-font">
                    <b>{{ "forgot_pwd.title" | translate }}</b>
                </mat-card-title>
            </div>
            <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24 orgApp-frgt-pwd-card orgApp-text-center orgApp-align-i-center">
               
                <mat-card-content
                    class="mat-typography orgApp-frgt-pwd-dialog-content orgApp-align-i-center orgApp-flex-dir-col orgApp-gap-24">
                    <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8 orgApp-frgt-pwd-para-mar orgApp-margin-top-12">
                        <p class="orgApp-frgt-pwd-para orgApp-frgt-pwd-margin orgApp-frgt-pwd-font orgApp-frgt-pwd-width">
                            {{ "forgot_pwd.desc" | translate }}
                        </p>
                    </div>
                    <form [formGroup]="forgotPwdForm" class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24">
                        <mat-form-field appearance="fill" hideRequiredMarker="true"
                            class="orgApp-frgt-pwd-width orgApp-login-field orgApp-frgt-pwd-fd orgApp-field-rounded-lg orgApp-input-field-md"
                            [ngClass]="{
                                error: forgotPwdForm.get('email')?.invalid && forgotPwdForm.get('email')?.touched
                            }"
                        >
                            <mat-label class="orgApp-login-form-label">
                                {{ "login.content.placeholder.username" | translate }}
                            </mat-label>

                            <svg matPrefix width="24" height="24" fill="none">
                                <use xlink:href="#icon-mail"></use>
                            </svg>
                            <input matInput class="orgApp-login-input" placeholder="johndoe@gmail.com"  formControlName="email" (input)="trimSpaces('email')" />
                        </mat-form-field>

                        @if (forgotPwdForm.get('email')?.touched) {
                            <ng-container>
                                @if (forgotPwdForm.get('email')?.errors?.['invalid']) {
                                    <mat-error class="orgApp-frgt-pwd-err" [ngClass]="{'orgApp-login-error-label': forgotPwdForm.get('email')?.errors?.['invalid']}">
                                        {{ "login.content.error.username.invalid" | translate }}
                                    </mat-error>
                                }
                            </ng-container>
                        }
                    </form>
                </mat-card-content>
                <div class="orgApp-frgt-pwd-btn-container orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24">
                    <button mat-raised-button
                        class="orgApp-frgt-pwd-action-btn orgApp-frgt-pwd-font orgApp-sign-in-btn orgApp-frgt-pwd-width"
                        [disabled]="!enableBtn" [ngClass]="{
                disable: !enableBtn
                }" (click)="submitEmail()">
                        {{ "forgot_pwd.action.continue" | translate }}
                    </button>
                    <p class="orgApp-text-link orgApp-back-link orgApp-frgt-pwd-font" (click)="showLogin()">
                        <b>{{ "forgot_pwd.action.back_to_sign_in" | translate }}</b>
                    </p>
                </div>
            </div>
        </div>
    </mat-card>
</div>